var render = function render(_c,_vm){return _c('section',_vm._b({class:[_vm.data.class, _vm.data.staticClass, 'loading-overlay', { 'is-submit': _vm.props.isSubmit }],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"role":"status","aria-label":"Loading"}},'section',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }